export default __webpack_public_path__ + "static/media/more-coin.18045136.webp";